import { PROVIDER_SOURCE } from '../../constants/quote';
import { BusinessTypeSoleProprietor, BusinessTypeSoleTrader } from '../../localeConstants';
import { getLocalTranslation } from '../i18nKit';
export var QuoteFormSectionTitleInfoEnum;
/**
 * Resolve the display title info (`label` / `itemLabel` / `note`) for a quote form section.
 *
 * Extracted from `useQuoteDataFormDisplayMap` as a plain function (not a hook) so both
 * React consumers (via the hook) and non-React utilities (e.g. the application form
 * builders in `utils/quote/applicationForm`) share one source of truth for titles.
 */

(function (QuoteFormSectionTitleInfoEnum) {
  QuoteFormSectionTitleInfoEnum["personalDetails"] = "personalDetails";
  QuoteFormSectionTitleInfoEnum["businessDetails"] = "businessDetails";
  QuoteFormSectionTitleInfoEnum["businessType"] = "businessType";
  QuoteFormSectionTitleInfoEnum["companyAndAddress"] = "companyAndAddress";
  QuoteFormSectionTitleInfoEnum["recruitmentBusinessType"] = "recruitmentBusinessType";
  QuoteFormSectionTitleInfoEnum["estimatedTurnover"] = "estimatedTurnover";
  QuoteFormSectionTitleInfoEnum["retroactiveCoverDate"] = "retroactiveCoverDate";
  QuoteFormSectionTitleInfoEnum["policyStartDate"] = "policyStartDate";
  QuoteFormSectionTitleInfoEnum["recruitmentEstimatedSplit"] = "recruitmentEstimatedSplit";
  QuoteFormSectionTitleInfoEnum["incomeSplit"] = "incomeSplit";
  QuoteFormSectionTitleInfoEnum["payrollForPlacedCandidates"] = "payrollForPlacedCandidates";
  QuoteFormSectionTitleInfoEnum["placementIndustriesPercentage"] = "placementIndustriesPercentage";
  QuoteFormSectionTitleInfoEnum["employerReferenceNumber"] = "employerReferenceNumber";
  QuoteFormSectionTitleInfoEnum["coverType"] = "coverType";
  QuoteFormSectionTitleInfoEnum["claims"] = "claims";
  QuoteFormSectionTitleInfoEnum["typeOfPolicy"] = "typeOfPolicy";
  QuoteFormSectionTitleInfoEnum["businessActivity"] = "businessActivity";
  QuoteFormSectionTitleInfoEnum["covers"] = "covers";
  QuoteFormSectionTitleInfoEnum["numberOfEmployees"] = "numberOfEmployees";
  QuoteFormSectionTitleInfoEnum["insuranceBundle"] = "insuranceBundle";
  QuoteFormSectionTitleInfoEnum["employees"] = "employees";
  QuoteFormSectionTitleInfoEnum["vehicles"] = "vehicles";
  QuoteFormSectionTitleInfoEnum["personalData"] = "personalData";
  QuoteFormSectionTitleInfoEnum["placedCandidateSplit"] = "placedCandidateSplit";
  QuoteFormSectionTitleInfoEnum["portableEquipmentInsured"] = "portableEquipmentInsured";
  QuoteFormSectionTitleInfoEnum["businessInterruptionInsured"] = "businessInterruptionInsured";
  QuoteFormSectionTitleInfoEnum["propertyList"] = "propertyList";
  QuoteFormSectionTitleInfoEnum["dotNumber"] = "dotNumber";
  QuoteFormSectionTitleInfoEnum["typeOfOperation"] = "typeOfOperation";
  QuoteFormSectionTitleInfoEnum["averageRadiusOfOperation"] = "averageRadiusOfOperation";
  QuoteFormSectionTitleInfoEnum["yearsInBusiness"] = "yearsInBusiness";
  QuoteFormSectionTitleInfoEnum["numberOfDrivers"] = "numberOfDrivers";
  QuoteFormSectionTitleInfoEnum["minorViolations"] = "minorViolations";
  QuoteFormSectionTitleInfoEnum["r2ROption"] = "r2ROption";
  QuoteFormSectionTitleInfoEnum["customInputCoverages"] = "customInputCoverages";
  QuoteFormSectionTitleInfoEnum["businessExpectedRevenue"] = "businessExpectedRevenue";
  QuoteFormSectionTitleInfoEnum["estSalesLargestProject"] = "estSalesLargestProject";
  QuoteFormSectionTitleInfoEnum["expectedGrossSalesFromCustomer"] = "expectedGrossSalesFromCustomer";
  QuoteFormSectionTitleInfoEnum["businessClass"] = "businessClass";
  QuoteFormSectionTitleInfoEnum["professionalAssociationsMember"] = "professionalAssociationsMember";
  QuoteFormSectionTitleInfoEnum["accountancyActivityList"] = "accountancyActivityList";
  QuoteFormSectionTitleInfoEnum["businessBegin"] = "businessBegin";
  QuoteFormSectionTitleInfoEnum["squareFeetOccupiedByYou"] = "squareFeetOccupiedByYou";
  QuoteFormSectionTitleInfoEnum["estmtdPayrollExpense"] = "estmtdPayrollExpense";
  QuoteFormSectionTitleInfoEnum["numOfOwners"] = "numOfOwners";
  QuoteFormSectionTitleInfoEnum["annualPrivacyMattersTraining"] = "annualPrivacyMattersTraining";
  QuoteFormSectionTitleInfoEnum["buildingOwnership"] = "buildingOwnership";
  QuoteFormSectionTitleInfoEnum["professionalLicenseAttestation"] = "professionalLicenseAttestation";
  QuoteFormSectionTitleInfoEnum["subcontractProfessionalServices"] = "subcontractProfessionalServices";
  QuoteFormSectionTitleInfoEnum["subcontractProfessionalServices2"] = "subcontractProfessionalServices2";
  QuoteFormSectionTitleInfoEnum["designConstructionRepair"] = "designConstructionRepair";
  QuoteFormSectionTitleInfoEnum["designConstructionRepair2"] = "designConstructionRepair2";
  QuoteFormSectionTitleInfoEnum["berAssessor"] = "berAssessor";
  QuoteFormSectionTitleInfoEnum["hearAboutUs"] = "hearAboutUs";
  QuoteFormSectionTitleInfoEnum["staffExperienceYears"] = "staffExperienceYears";
  QuoteFormSectionTitleInfoEnum["workRequireCertifiedPercentage"] = "workRequireCertifiedPercentage";
  QuoteFormSectionTitleInfoEnum["writtenContractPercentage"] = "writtenContractPercentage";
  QuoteFormSectionTitleInfoEnum["subcontractorPercentage"] = "subcontractorPercentage";
  QuoteFormSectionTitleInfoEnum["totalCostClaims"] = "totalCostClaims";
  QuoteFormSectionTitleInfoEnum["totalInsurancePremiumPaid"] = "totalInsurancePremiumPaid";
  QuoteFormSectionTitleInfoEnum["insurancePolicyInEffect"] = "insurancePolicyInEffect";
  QuoteFormSectionTitleInfoEnum["quickJourneyCriteria"] = "quickJourneyCriteria";
  QuoteFormSectionTitleInfoEnum["typeOfRemovalJob"] = "typeOfRemovalJob";
  QuoteFormSectionTitleInfoEnum["typeOfCommodities"] = "typeOfCommodities";
  QuoteFormSectionTitleInfoEnum["numberOfLosses"] = "numberOfLosses";
  QuoteFormSectionTitleInfoEnum["limitedEmployeeCount"] = "limitedEmployeeCount";
  QuoteFormSectionTitleInfoEnum["dateOfBirth"] = "dateOfBirth";
})(QuoteFormSectionTitleInfoEnum || (QuoteFormSectionTitleInfoEnum = {}));

export var getQuoteFormDisplayTitleInfo = function getQuoteFormDisplayTitleInfo(type, config) {
  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t;

  var str = '';
  var itemStr = '';
  var note = '';
  var quoteTitle = '';

  switch (type) {
    case QuoteFormSectionTitleInfoEnum.personalDetails:
      itemStr = str = 'Contact information';
      break;

    case QuoteFormSectionTitleInfoEnum.businessDetails:
      itemStr = str = $t('kit:quotes.your_business_details');
      break;

    case QuoteFormSectionTitleInfoEnum.businessType:
      quoteTitle = 'Your business type';
      itemStr = str = $t('kit:quotes.business_type');
      break;

    case QuoteFormSectionTitleInfoEnum.companyAndAddress:
      itemStr = str = [BusinessTypeSoleTrader, BusinessTypeSoleProprietor].includes(config === null || config === void 0 ? void 0 : config.businessType) ? $t('kit:quotes.trading_name_and_address') : $t('kit:quotes.company_name_and_address');
      break;

    case QuoteFormSectionTitleInfoEnum.recruitmentBusinessType:
      itemStr = str = $t('kit:quotes.recruitment_business_type');
      break;

    case QuoteFormSectionTitleInfoEnum.retroactiveCoverDate:
      str = $t('kit:quotes.your_retroactive_cover_date_optional');
      itemStr = $t('kit:quotes.retroactive_date');
      break;

    case QuoteFormSectionTitleInfoEnum.policyStartDate:
      str = $t('kit:quotes.your_policy_start_date');
      itemStr = $t('kit:quotes.policy_start_date');
      break;

    case QuoteFormSectionTitleInfoEnum.estimatedTurnover:
      itemStr = str = $t('kit:quotes.annual_estimated_turnover');
      break;

    case QuoteFormSectionTitleInfoEnum.recruitmentEstimatedSplit:
      itemStr = str = $t('kit:quotes.approximate_business_undertakings_recruitment_payroll');
      break;

    case QuoteFormSectionTitleInfoEnum.incomeSplit:
      str = $t('kit:quotes.what_percentage_income_is_generated_from') + '?';
      itemStr = $t('kit:quotes.income_split');
      break;

    case QuoteFormSectionTitleInfoEnum.payrollForPlacedCandidates:
      quoteTitle = 'What is the approximate payroll for your placed candidates (under umbrella/payroll contract)?';
      itemStr = str = $t('kit:quotes.approximate_payroll_placed_candidates_umbrella');
      break;

    case QuoteFormSectionTitleInfoEnum.placementIndustriesPercentage:
      itemStr = str = $t('kit:quotes.relevant_placement_industries');
      break;

    case QuoteFormSectionTitleInfoEnum.employerReferenceNumber:
      itemStr = str = $t('kit:quotes.employer_reference_number_optional');
      break;

    case QuoteFormSectionTitleInfoEnum.coverType:
      itemStr = str = $t('kit:quotes.cover_type');
      break;

    case QuoteFormSectionTitleInfoEnum.claims:
      itemStr = str = $t('kit:quotes.claim');
      break;

    case QuoteFormSectionTitleInfoEnum.typeOfPolicy:
      itemStr = str = $t('kit:quotes.policy_type');
      break;

    case QuoteFormSectionTitleInfoEnum.businessActivity:
      quoteTitle = 'Which option best suits your business activities?';
      itemStr = str = $t('kit:quotes.business_activity');
      break;

    case QuoteFormSectionTitleInfoEnum.covers:
      itemStr = str = $t('kit:quotes.your_coverages');
      break;

    case QuoteFormSectionTitleInfoEnum.numberOfEmployees:
      str = $t('kit:quotes.how_many_employees_in_the_business');
      itemStr = $t('kit:quotes.number_of_employees');
      break;

    case QuoteFormSectionTitleInfoEnum.employees:
      quoteTitle = 'How many employees do you have in the business?';
      str = $t('kit:quotes.how_many_employees_in_the_business');
      itemStr = $t('kit:quotes.number_of_employees');

      if ([PROVIDER_SOURCE().HISCOX_US.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
        itemStr = str = 'Including yourself, how many full-time, part-time, and temporary employees does your business have? (Do not include subcontractors.)';
      } else if ([PROVIDER_SOURCE().RECRUITMENT.value].includes(config === null || config === void 0 ? void 0 : config.providerCode)) {
        itemStr = 'Number of Own Employees (Excluding any placed candidates)';
      }

      break;

    case QuoteFormSectionTitleInfoEnum.insuranceBundle:
      itemStr = str = $t('kit:quotes.insurance_bundle');
      break;

    case QuoteFormSectionTitleInfoEnum.vehicles:
      itemStr = str = $t('kit:quotes.vehicles');
      break;

    case QuoteFormSectionTitleInfoEnum.personalData:
      itemStr = str = $t('kit:quotes.personal_details');
      break;

    case QuoteFormSectionTitleInfoEnum.placedCandidateSplit:
      itemStr = str = $t('kit:quotes.approximate_split_candidates_permanent_temporary');
      break;

    case QuoteFormSectionTitleInfoEnum.portableEquipmentInsured:
      str = $t('kit:quotes.portable_equipment');
      itemStr = $t('kit:total_value_portable_equipment_use_business_globally');
      break;

    case QuoteFormSectionTitleInfoEnum.businessInterruptionInsured:
      str = $t('kit:quotes.business_interruption_cover');
      itemStr = $t('kit:quotes.sum_insured_increased_cost_business_interruption');
      break;

    case QuoteFormSectionTitleInfoEnum.propertyList:
      str = $t('kit:quotes.property_details');
      itemStr = $t('kit:quotes.property_details');
      break;

    case QuoteFormSectionTitleInfoEnum.dotNumber:
      str = 'What is your DOT number? (6 to 8 digits)';
      itemStr = 'DOT number';
      break;

    case QuoteFormSectionTitleInfoEnum.typeOfOperation:
      itemStr = str = 'What type of removal job do you carry out?';
      break;

    case QuoteFormSectionTitleInfoEnum.averageRadiusOfOperation:
      quoteTitle = itemStr = str = 'What is your average radius of operation?';
      break;

    case QuoteFormSectionTitleInfoEnum.yearsInBusiness:
      quoteTitle = itemStr = str = 'How many years have you been in business for?';
      break;

    case QuoteFormSectionTitleInfoEnum.numberOfDrivers:
      quoteTitle = itemStr = str = 'How many drivers do you have?';
      break;

    case QuoteFormSectionTitleInfoEnum.minorViolations:
      quoteTitle = itemStr = str = 'What is the total number of minor violations for all drivers within the past 3 years?';
      break;

    case QuoteFormSectionTitleInfoEnum.r2ROption:
      itemStr = str = 'Rent to Rent Option';
      break;

    case QuoteFormSectionTitleInfoEnum.customInputCoverages:
      itemStr = str = 'Custom Coverages';
      break;

    case QuoteFormSectionTitleInfoEnum.businessExpectedRevenue:
      str = "For the next 12 months, what is your business's expected revenue?";
      itemStr = 'Business expected revenue';
      break;

    case QuoteFormSectionTitleInfoEnum.estSalesLargestProject:
      str = 'During the next 12 months, what is the expected gross revenue you will earn from your largest project?';
      itemStr = 'Expected gross sales from your largest project';
      break;

    case QuoteFormSectionTitleInfoEnum.expectedGrossSalesFromCustomer:
      str = 'During the next 12 months, what are the expected gross sales will you earn from your largest customer?';
      itemStr = 'Expected gross sales from your largest customer';
      break;

    case QuoteFormSectionTitleInfoEnum.businessClass:
      str = 'What is your main business class/profession?';
      itemStr = 'Business class';
      break;

    case QuoteFormSectionTitleInfoEnum.professionalAssociationsMember:
      itemStr = str = 'Professional association member';
      break;

    case QuoteFormSectionTitleInfoEnum.accountancyActivityList:
      str = 'Which of these accountancy activities do you undertake?';
      itemStr = 'Accountancy activities';
      break;

    case QuoteFormSectionTitleInfoEnum.businessBegin:
      str = 'Approximately when did your business begin?';
      itemStr = 'Business begin date';
      break;

    case QuoteFormSectionTitleInfoEnum.squareFeetOccupiedByYou:
      str = 'Approximately how many square feet does your business occupy at this location?';
      itemStr = 'Square feet occupied by you';
      break;

    case QuoteFormSectionTitleInfoEnum.estmtdPayrollExpense:
      str = "For the next 12 months, what is your business's expected payroll?";
      itemStr = 'Expected payroll';
      break;

    case QuoteFormSectionTitleInfoEnum.numOfOwners:
      str = "How many owners are there in your company?";
      itemStr = 'Number of owners';
      note = 'Note: Owners include active partners and executive officers.';
      break;

    case QuoteFormSectionTitleInfoEnum.annualPrivacyMattersTraining:
      str = "Do you conduct annual training for employees with respect to privacy matters?";
      itemStr = 'Annual privacy matters training';
      break;

    case QuoteFormSectionTitleInfoEnum.buildingOwnership:
      str = "Does your business own and need coverage for the building?";
      itemStr = 'Building ownership';
      break;

    case QuoteFormSectionTitleInfoEnum.professionalLicenseAttestation:
      str = "If required by state law, do you or the principal of your firm maintain current and valid professional training, certifications, licenses or designations for all services you provide?";
      itemStr = 'Professional license attestation';
      break;

    case QuoteFormSectionTitleInfoEnum.subcontractProfessionalServices:
      str = "Does your business subcontract any professional services?";
      itemStr = 'Subcontract professional services';
      break;

    case QuoteFormSectionTitleInfoEnum.subcontractProfessionalServices2:
      str = "Do you agree with the following statements about your subcontracted services?";
      itemStr = 'Subcontract professional services';
      break;

    case QuoteFormSectionTitleInfoEnum.designConstructionRepair:
      str = "Does your business perform any design, construction, installation, removal, or physical repair of any property or tangible good?";
      itemStr = 'Design, construction & repair';
      break;

    case QuoteFormSectionTitleInfoEnum.designConstructionRepair2:
      str = "Is this limited to the installation, removal, or repair of software, hardware, computer equipment and other technology peripherals?";
      itemStr = 'Design, construction & repair';
      break;

    case QuoteFormSectionTitleInfoEnum.berAssessor:
      itemStr = str = 'Registration details';
      break;

    case QuoteFormSectionTitleInfoEnum.hearAboutUs:
      str = 'Where did you hear about us?';
      itemStr = 'Hear about us';
      break;

    case QuoteFormSectionTitleInfoEnum.staffExperienceYears:
      itemStr = str = 'Average years of staff professional experience';
      break;

    case QuoteFormSectionTitleInfoEnum.workRequireCertifiedPercentage:
      itemStr = str = 'What % of your professionals are licensed, certified, or accredited in their field?';
      break;

    case QuoteFormSectionTitleInfoEnum.writtenContractPercentage:
      itemStr = str = 'Do you use written contracts with clients for most of your work?';
      break;

    case QuoteFormSectionTitleInfoEnum.subcontractorPercentage:
      itemStr = str = 'What % of your work is subcontracted?';
      break;

    case QuoteFormSectionTitleInfoEnum.totalCostClaims:
      itemStr = str = 'Total cost of all claims including open claims';
      break;

    case QuoteFormSectionTitleInfoEnum.totalInsurancePremiumPaid:
      itemStr = str = 'Total insurance premium paid in the last 5 years';
      break;

    case QuoteFormSectionTitleInfoEnum.insurancePolicyInEffect:
      itemStr = str = 'Do you currently have an insurance policy in effect for the coverage requested?';
      break;

    case QuoteFormSectionTitleInfoEnum.quickJourneyCriteria:
      itemStr = str = 'Fast process criteria';
      break;

    case QuoteFormSectionTitleInfoEnum.typeOfRemovalJob:
      itemStr = 'Type of removal job';
      str = 'What type of removal job do you carry out?';
      break;

    case QuoteFormSectionTitleInfoEnum.typeOfCommodities:
      itemStr = 'Type of commodities';
      str = 'What type of commodities do you haul?';
      break;

    case QuoteFormSectionTitleInfoEnum.numberOfLosses:
      itemStr = 'Number of cargo losses';
      quoteTitle = str = 'How many cargo losses did you have in the past 3 years?';
      break;

    case QuoteFormSectionTitleInfoEnum.limitedEmployeeCount:
      itemStr = str = 'How many employees are there in your company (include full time and part time)?';
      note = 'Note: Exclude owners, clerical employees, independent contractors, or subcontractors.';
      break;

    case QuoteFormSectionTitleInfoEnum.dateOfBirth:
      quoteTitle = 'What is your date of birth?';
      itemStr = str = 'Date of birth';
      break;

    default:
      itemStr = str = '';
  }

  return {
    quoteTitle: quoteTitle,
    label: str,
    itemLabel: itemStr,
    note: note
  };
};